"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const HelpIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_464_13)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8 0a8 8 0 100 16A8 8 0 008 0zm-.896 8.42c-.154.378-.232.886-.232 1.524h1.75l.027-.417c.05-.446.249-.836.595-1.169l.554-.526c.433-.42.736-.8.909-1.142.173-.346.26-.713.26-1.1 0-.852-.267-1.51-.8-1.976-.533-.47-1.283-.704-2.249-.704-.957 0-1.714.246-2.27.738-.551.493-.831 1.174-.84 2.044H6.79c.01-.364.114-.649.314-.854.206-.21.477-.315.814-.315.71 0 1.066.386 1.066 1.156 0 .255-.068.499-.205.731-.136.228-.412.527-.827.896-.41.364-.693.736-.848 1.114zm-.123 2.871a.995.995 0 00-.307.752c0 .3.1.55.3.745.206.196.475.294.807.294.333 0 .6-.098.8-.294a.986.986 0 00.308-.745.984.984 0 00-.315-.752c-.205-.2-.47-.3-.793-.3-.323 0-.59.1-.8.3z",
    clipRule: "evenodd"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_464_13"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0h16v16H0z"
  })))))
});
HelpIcon.displayName = 'HelpIcon';
var _default = exports.default = HelpIcon;